import useRoutesHandler from "@/Hooks/useRouteHandler";
import { sideTabSchema } from "@/Routes/sidebar.utility";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { useEffect, useRef, useState } from "react";
import SideHref from "./SideHref";
import SubTabSideTabs from "./SubTabSideTabs";

type TSideTabProps = {
  tabData?: sideTabSchema | null;
  mainTab?: boolean;
  expandSidebar: boolean;
};

function SideTab({ tabData, expandSidebar }: TSideTabProps) {
  //STATES
  const [subTabOpen, openSubNav] = useState(false);
  //HOOKS
  const { activeRoutes } = useRoutesHandler();
  // VARIABLE/s
  const hasSubTabs = !!tabData?.subTabs?.length;
  const parentTabRef = useRef<HTMLDivElement>(null);

  const isRouteActive = activeRoutes.includes(
    stringUtility.removeSpaceAddChar(String(tabData?.name), "-")
  );
  const isTabActive = hasSubTabs ? !subTabOpen && isRouteActive : isRouteActive;

  //EFFECT/s
  useEffect(() => {
    if (!hasSubTabs) {
      openSubNav(false);
      return;
    }
    if (
      activeRoutes.includes(stringUtility.removeSpaceAddChar(tabData.name, "-"))
    ) {
      openSubNav(true);
    } else {
      openSubNav(false);
    }
  }, [
    activeRoutes.includes(
      stringUtility.removeSpaceAddChar(String(tabData?.name), "-")
    ),
  ]);

  useEffect(() => {
    if (subTabOpen && parentTabRef.current) {
      parentTabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [subTabOpen]);

  return (
    <div ref={parentTabRef}>
      <SideHref
        key={tabData?.name}
        tabData={tabData}
        isActive={isTabActive}
        onClick={() => {
          tabData?.subTabs && openSubNav(!subTabOpen);
        }}
        expandSidebar={expandSidebar}
        hrefTo={tabData?.path}
        isTabOpen={subTabOpen}
      />
      {subTabOpen && (
        <SubTabSideTabs tabData={tabData} expandSidebar={expandSidebar} />
      )}
    </div>
  );
}

export default SideTab;
